// MerchantOrdersScreen/OrderTable.jsx

import React from "react";
import { TablePlaceholder } from "../../components/placeholders";
import ProductRow from "./productRow";

const COLUMN_WIDTHS = {
  code: "10%",
  address: "34%",
  amount: "14%",
  date: "14%",
  minute: "14%",
  status: "14%",
};

export default function OrderTable({ orders, loading, onRowClick }) {
  return (
    <table className="table table-centered mb-0">
      <thead>
        <tr>
          <th style={{ width: COLUMN_WIDTHS.code, textAlign: "center" }}>
            Код
          </th>
          <th style={{ width: COLUMN_WIDTHS.address, textAlign: "center" }}>
            Хаяг
          </th>
          <th style={{ width: COLUMN_WIDTHS.amount, textAlign: "center" }}>
            Нийт үнэ
          </th>
          <th style={{ width: COLUMN_WIDTHS.date, textAlign: "center" }}>
            Огноо
          </th>
          <th style={{ width: COLUMN_WIDTHS.minute, textAlign: "center" }}>
            Минут
          </th>
          <th style={{ width: COLUMN_WIDTHS.status, textAlign: "center" }}>
            Төлөв
          </th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <TablePlaceholder count={6} />
        ) : (
          orders?.map((item) => (
            <ProductRow
              key={item.id}
              item={item}
              onClick={() => onRowClick(item)}
            />
          ))
        )}
      </tbody>
    </table>
  );
}
